import axios from 'axios'

const request = axios.create({})

export default request